import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry error monitoring (no-op if DSN not set)
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  environment:
    import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true"
      ? "development"
      : "production",
  release: `the-love-contract@${import.meta.env.VITE_APP_VERSION}+${import.meta.env.VITE_GIT_COMMIT}`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <App />
  </ThemeProvider>
);
